import styled from 'styled-components';

export const AppContainer = styled.div`
  height: 100%;
  font-family: ${(props) => props.theme.fontFamily};
`;
